export default { crud: ['create', 'update', 'read', 'delete'] };
